/* oxlint-disable lingui/no-unlocalized-strings */
// Don't translate for single language organizations
import { Text } from "@medoma/components/Text/Text";

export const GuideTemplateSUSLund = () => (
  <>
    <Text element="p">Information till dig som får sjukhusvård hemma</Text>
    <Text element="p">
      Sjukhus hemma vid Skånes universitetssjukhus erbjuder dig vård i hemmet
      som ett alternativ till att vårdas på sjukhus. I stället för att vara på
      sjukhuset under tiden som du behöver specialistvård kan du få vården i
      hemmet.
    </Text>
    <Text element="p">
      Personalen som jobbar med Sjukhus hemma avgör tillsammans med dig om
      sjukhusvård i hemmet är en lämplig vårdform för dig. I så fall kommer
      teamet hem till dig, ställer i ordning utrustning och kontrollerar att
      allt fungerar som det ska. Innan teamet går bestämmer ni tillsammans vad
      som ska hända framöver; när teamet eller sjuksköterskan kommer nästa gång,
      vilka åtgärder som planeras och om du själv ska göra något, till exempel
      ta vikt, blodtryck och puls, morgon och kväll.
    </Text>
    <Text element="p">
      Teamet besöker dig i ditt hem varje dag och ger den vård du behöver. När
      du inte längre behöver specialistsjukvård, skrivs du ut på samma sätt som
      om du hade varit på sjukhuset. Sedan är det som vanligt din vårdcentral du
      ska vända dig till.
    </Text>
    <Text element="p">
      Du måste orka med att sköta matlagning, hygien med mera hemma, så som du
      brukar göra, eller om du har hemtjänst som hjälper dig med detta eftersom
      Sjukhus hemma inte kan hjälpa till med den typen av uppgifter.
    </Text>
    <Text element="p">
      Du kan dygnet runt ringa direktnumret, 046-755 00 29. Du behöver alltså
      inte ringa via växeln för att nå teamet.
    </Text>
    <Text element="p">
      Du kan också komma i kontakt med teamet via läsplattan som du får låna med
      dig hem. Där kan du skriva chattmeddelanden och teamet svarar dig på
      plattan. Om du vill att vi ses i ett videosamtal kopplar personalen upp
      det på plattan. Du kan chatta med teamet kl. 08.00-15.30.
    </Text>
  </>
);
